<script setup>
const emit = defineEmits(['submit'])

const props = defineProps({
  priceInfo: {
    type: Object,
    required: true,
    default: {}
  }
})

const languageStore = useLanguage()

const cms = useCms()

// create common with computed
const common = computed(() => cms.value?.common)

async function onSubmit() {
  emit('submit')
}
</script>

<template>
  <div class="fixed bottom-0 left-0 flex flex-col w-full z-50">
    <AccordionPayment
      cms-key="payment_pricebox_info"
      :title="common?.payment_pricebox_info"
      class="bg-white"
    >
      <template #title="{ isOpen }">
        <div class="flex flex-row justify-between items-center w-full">
          <div
            class="font-bold text-base text-dark"
            cms-key="payment_pricebox_info"
          >
            {{ common?.payment_pricebox_info }}
          </div>
          <div class="flex items-center gap-x-4">
            <div
              class="font-semibold text-sm text-dark-gray"
              cms-key="text_day"
            >
              {{ priceInfo?.totalDays }} {{ common?.text_day }}
            </div>
            <div
              v-if="isOpen"
              class="flex justify-between items-center text-xs text-green-500 font-semibold"
            >
              <div cms-key="text_daily_price">
                {{ common?.text_daily_price }}:
              </div>
              <div>
                {{
                  useCurrency(
                    languageStore,
                    priceInfo?.sitePrice?.amount?.currency,
                    (priceInfo?.totalCardPay + priceInfo?.totalOfficePay) /
                      100 /
                      priceInfo?.totalDays
                  )
                }}
              </div>
            </div>
            <div v-else class="font-bold text-lg text-dark-gray">
              {{
                useCurrency(
                  languageStore,
                  priceInfo?.currency,
                  (priceInfo?.totalCardPay + priceInfo?.totalOfficePay) / 100
                )
              }}
            </div>
          </div>
        </div>
      </template>
      <template #content>
        <div class="h-full max-h-[60dvh] overflow-y-auto">
          <div class="bg-main-other-100 px-6 py-3">
            <!-- <div
            class="h-[25px] bg-steel rounded-md grid place-content-center text-white font-semibold text-sm"
          >
            Turkcell Platinum
          </div> -->
            <div class="py-3 flex flex-col gap-y-[10px] divide-y">
              <div class="flex justify-between items-center text-dark-gray">
                <div
                  class="text-sm font-semibold"
                  cms-key="payment_pricebox_text1"
                >
                  {{ common?.payment_pricebox_text1 }}
                </div>
                <div class="text-lg font-bold">
                  {{
                    useCurrency(
                      languageStore,
                      priceInfo?.currency,
                      priceInfo?.totalCardPay / 100
                    )
                  }}
                </div>
              </div>
              <PriceBoxItem
                v-for="item in priceInfo?.cardPay"
                :item="item"
                :key="item"
              ></PriceBoxItem>
              <div
                v-if="priceInfo?.officePay?.length"
                class="pt-3 flex justify-between items-center text-dark-gray"
              >
                <div
                  class="text-sm font-semibold"
                  cms-key="payment_pricebox_text2"
                >
                  {{ common?.payment_pricebox_text2 }}
                </div>
                <div class="text-lg font-bold">
                  {{
                    useCurrency(
                      languageStore,
                      priceInfo?.currency,
                      priceInfo?.totalOfficePay / 100
                    )
                  }}
                </div>
              </div>
              <PriceBoxItem
                v-for="item in priceInfo?.officePay"
                :item="item"
                :key="item"
              ></PriceBoxItem>
            </div>
          </div>
          <div class="py-3 px-6 bg-white">
            <div class="flex justify-between items-center">
              <div
                class="text-base text-dark font-bold"
                cms-key="payment_pricebox_total_price"
              >
                {{ common?.payment_pricebox_total_price }}
              </div>
              <div class="text-lg text-dark-gray font-bold">
                {{
                  useCurrency(
                    languageStore,
                    priceInfo?.currency,
                    (priceInfo?.totalCardPay + priceInfo?.totalOfficePay) / 100
                  )
                }}
              </div>
            </div>
          </div>
          <div
            v-if="priceInfo?.includedCoverages?.length"
            @click="$emit('clickIncluded')"
            class="py-3 px-6 bg-button-tertiary border-t flex justify-between font-bold text-sm text-dark cursor-pointer"
          >
            <div
              class="text-main-other-500 text-sm font-bold"
              cms-key="included_in_price"
            >
              {{ common?.included_in_price }}
            </div>
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </template>
    </AccordionPayment>
    <Button @click="onSubmit" size="xl" class="w-full h-[51px] rounded-none">
      <div class="w-full grid grid-flow-col">
        <div class="justify-self-end self-center" cms-key="button_rent_now">
          {{ common?.button_rent_now }}
        </div>
        <i class="icon-chevron-right justify-self-end self-center"></i>
      </div>
    </Button>
  </div>
</template>

<style lang="scss" scoped></style>
